export default __webpack_public_path__ + "static/media/press-mob.db72909c.png";